var _path, _g, _path2, _path3, _path4, _g2, _path5, _path6, _path7, _g3, _path8, _path9, _path10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoComments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 272,
    height: 194,
    viewBox: "0 0 272 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M221.745 0H55.7873C48.1493 0 41.9575 6.19181 41.9575 13.8298V179.787C41.9575 187.425 48.1493 193.617 55.7873 193.617H221.745C229.383 193.617 235.575 187.425 235.575 179.787V13.8298C235.575 6.19181 229.383 0 221.745 0Z",
    fill: "#3A8F78"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1197_5114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.3829 74.6809H259.085C260.919 74.6809 262.678 75.4094 263.975 76.7062C265.271 78.003 266 79.7619 266 81.5958V116.17C266 118.004 265.271 119.763 263.975 121.06C262.678 122.357 260.919 123.085 259.085 123.085H72.3829C70.549 123.085 68.7901 122.357 67.4933 121.06C66.1965 119.763 65.468 118.004 65.468 116.17V81.5958C65.468 79.7619 66.1965 78.003 67.4933 76.7062C68.7901 75.4094 70.549 74.6809 72.3829 74.6809V74.6809Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M174.723 85.7446H138.766C136.474 85.7446 134.617 87.6022 134.617 89.8936C134.617 92.185 136.474 94.0425 138.766 94.0425H174.723C177.015 94.0425 178.872 92.185 178.872 89.8936C178.872 87.6022 177.015 85.7446 174.723 85.7446Z",
    fill: "#BADAD1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M199.617 103.723H138.766C136.474 103.723 134.617 105.581 134.617 107.872C134.617 110.164 136.474 112.021 138.766 112.021H199.617C201.908 112.021 203.766 110.164 203.766 107.872C203.766 105.581 201.908 103.723 199.617 103.723Z",
    fill: "#BADAD1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.649 112.021C114.905 112.021 120.787 106.139 120.787 98.8829C120.787 91.6268 114.905 85.7446 107.649 85.7446C100.393 85.7446 94.5105 91.6268 94.5105 98.8829C94.5105 106.139 100.393 112.021 107.649 112.021Z",
    fill: "#1A6751"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1197_5114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9149 134.149H199.617C201.451 134.149 203.21 134.877 204.507 136.174C205.803 137.471 206.532 139.23 206.532 141.064V175.638C206.532 177.472 205.803 179.231 204.507 180.528C203.21 181.825 201.451 182.553 199.617 182.553H12.9149C11.081 182.553 9.32212 181.825 8.02533 180.528C6.72853 179.231 6 177.472 6 175.638V141.064C6 139.23 6.72853 137.471 8.02533 136.174C9.32212 134.877 11.081 134.149 12.9149 134.149V134.149Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M115.255 145.213H79.2979C77.0065 145.213 75.1489 147.07 75.1489 149.362C75.1489 151.653 77.0065 153.511 79.2979 153.511H115.255C117.547 153.511 119.404 151.653 119.404 149.362C119.404 147.07 117.547 145.213 115.255 145.213Z",
    fill: "#BADAD1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M140.149 163.191H79.2979C77.0065 163.191 75.1489 165.049 75.1489 167.34C75.1489 169.632 77.0065 171.489 79.2979 171.489H140.149C142.44 171.489 144.298 169.632 144.298 167.34C144.298 165.049 142.44 163.191 140.149 163.191Z",
    fill: "#BADAD1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.202 171.489C37.4581 171.489 43.3403 165.607 43.3403 158.351C43.3403 151.095 37.4581 145.213 30.202 145.213C22.9459 145.213 17.0637 151.095 17.0637 158.351C17.0637 165.607 22.9459 171.489 30.202 171.489Z",
    fill: "#1A6751"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1197_5114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.617 15.2126H12.9149C9.0959 15.2126 6 18.3085 6 22.1275V56.702C6 60.521 9.0959 63.6169 12.9149 63.6169H199.617C203.436 63.6169 206.532 60.521 206.532 56.702V22.1275C206.532 18.3085 203.436 15.2126 199.617 15.2126Z",
    fill: "white"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M112.489 26.2764H76.532C74.2406 26.2764 72.3831 28.1339 72.3831 30.4253C72.3831 32.7167 74.2406 34.5742 76.532 34.5742H112.489C114.781 34.5742 116.638 32.7167 116.638 30.4253C116.638 28.1339 114.781 26.2764 112.489 26.2764Z",
    fill: "#BADAD1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M137.383 44.2551H76.532C74.2406 44.2551 72.3831 46.1127 72.3831 48.4041C72.3831 50.6955 74.2406 52.553 76.532 52.553H137.383C139.674 52.553 141.532 50.6955 141.532 48.4041C141.532 46.1127 139.674 44.2551 137.383 44.2551Z",
    fill: "#BADAD1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1808 52.553C55.4369 52.553 61.3191 46.6707 61.3191 39.4147C61.3191 32.1586 55.4369 26.2764 48.1808 26.2764C40.9247 26.2764 35.0425 32.1586 35.0425 39.4147C35.0425 46.6707 40.9247 52.553 48.1808 52.553Z",
    fill: "#1A6751"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1197_5114",
    x: 59.468,
    y: 71.6809,
    width: 212.532,
    height: 60.4043,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1197_5114"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1197_5114",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1197_5114",
    x: 0,
    y: 131.149,
    width: 212.532,
    height: 60.4043,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1197_5114"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1197_5114",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1197_5114",
    x: 0,
    y: 12.2126,
    width: 212.532,
    height: 60.4043,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1197_5114"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1197_5114",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoComments);
export default __webpack_public_path__ + "static/media/noComments.bd2b22c69ef1af1af4a8cd89c747bd45.svg";
export { ForwardRef as ReactComponent };